const notificationEn = {
	notificationTable: 'Notification',
	name: 'Name',
	message: 'Message',
	created: 'Created',
	notificationType: 'Notification Type',
	severity: 'Severity',
	read: 'Read',
};

export default notificationEn;